import { AudioEntry } from "./MediaPlayer";
import homm3Artwork from "./assets/ost/HOMM3_soundtrack.jpg";

let audioPlayer = null as HTMLAudioElement | null;

const getAudio = () => {
  if (!audioPlayer) {
    audioPlayer = document.getElementById(
      "current-podcast"
    ) as HTMLAudioElement;
  }
  return audioPlayer;
};

export function updatePositionState() {
  const audio = getAudio();
  if (audio && "setPositionState" in navigator.mediaSession) {
    navigator.mediaSession.setPositionState({
      duration: audio.duration,
      playbackRate: audio.playbackRate,
      position: audio.currentTime,
    });
  }
}

export const setActionHandlers = (
  playNext: null | (() => void),
  playPrevious: null | (() => void)
) => {
  navigator.mediaSession.setActionHandler("previoustrack", playPrevious);
  navigator.mediaSession.setActionHandler("nexttrack", playNext);
};

export const initiateControls = (
  audio: HTMLAudioElement,
  playNext: null | (() => void),
  playPrevious: null | (() => void)
) => {
  setActionHandlers(playNext, playPrevious);

  navigator.mediaSession.setActionHandler("play", async () => {
    await audio.play();
    updatePositionState();
  });

  navigator.mediaSession.setActionHandler("pause", () => {
    audio.pause();
    updatePositionState();
  });

  audio.addEventListener("play", () => {
    navigator.mediaSession.playbackState = "playing";
  });

  audio.addEventListener("pause", () => {
    navigator.mediaSession.playbackState = "paused";
  });

  navigator.mediaSession.setActionHandler("seekto", (details) => {
    if (details.seekTime === undefined) return;
    if (details.fastSeek && "fastSeek" in audio) {
      audio.fastSeek(details.seekTime);
      return;
    }
    audio.currentTime = details.seekTime;
    updatePositionState();
  });
};

export const setMetadata = (audio: AudioEntry) => {
  if ("mediaSession" in navigator) {
    if (!navigator.mediaSession.metadata) {
      navigator.mediaSession.metadata = new MediaMetadata({
        title: audio.name,
        artist: "Paul Romero",
        album: "Heroes of Might and Magic III",

        artwork: [{ src: homm3Artwork, sizes: "512x512", type: "image/jpg" }],
      });
    }
    navigator.mediaSession.metadata.title = audio.name;

    // TODO: Update playback state.
  }
};
